<template>
<!-- whitelabel.short.toLowerCase() === 'adac' -->
  <div v-if="false">
    <Separator />
    <div class="field content">
      <p>Ohne Einfluss auf den Vertrag und jederzeit widerrufbar willige ich ein, dass ich über den Postweg hinaus vom ADAC über folgende Medien beworben werde:</p>
      <div class="is-flex u-flex-wrap">
        <b-checkbox v-model="optinEmail" @input="optInTrigger" native-value="email" class="mr-4">
          E-Mail
        </b-checkbox>
        <b-checkbox v-model="optinPhone" @input="optInTrigger" native-value="phone" class="mr-4">
          Telefon
        </b-checkbox>

        <button class="button is-text mt-4" @click="isOptinOpen = !isOptinOpen" aria-controls="optinInfo">Infos zur Einwilligung</button>
      </div>

      <b-collapse :open.sync="isOptinOpen" aria-id="optinInfo" class="mt-4">
        <div class="notification mb-4">
          <div class="content">
            <h3>
              Telefon und E-Mail Werbung
            </h3>
            <div class="content">
              <p>Einwilligung für Werbung und Marktforschung über weitere Medien: Ohne Einfluss auf den Vertrag und jederzeit widerrufbar willige ich ein, dass ich über den Postweg hinaus vom ADAC* über E-Mail und/oder Telefon beworben werde.</p>

              <p>
                Wir leiten Ihre Daten nicht an Dritte außerhalb des ADAC* zu Werbezwecken weiter! Weitere Informationen zum Datenschutz erhalten Sie unter
                <a class="is-inline-block" rel="nooopener" href="https://www.adac-suedbayern.de/datenschutz/" target="_blank">https://www.adac-suedbayern.de/datenschutz/</a>
              </p>
              <p>
                Ihre Einwilligung können Sie jederzeit für die Zukunft widerrufen. Ihren Widerruf richten Sie bitte unter Angabe Ihrer Mitgliedsnummer per Post, Fax oder E-Mail an:<br />
                Anschrift:
              </p>
              <p>
                ADAC e.V., Mitgliederservice, Hansastraße 19, 80686 München, <span class="is-inline-block">Fax: 089 76 76 63 46</span> oder <span class="is-inline-block">E-Mail: <a href="mailto:service@adac.de">service@adac.de</a></span> Kennwort „Werbewiderruf“
              </p>

              <small>* ADAC e.V., ADAC SE, ADAC Stiftung, ADAC Versicherung AG, ADAC Autovermietung GmbH, ADAC Autoversicherung AG, ADAC Finanzdienste GmbH, ADAC Medien und Reise GmbH, ADAC Regionalclubs mit deren jeweiligen Tochtergesellschaften</small>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import Separator from '@/components/Separator'
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'AdacOptin',
  components: {
    Separator,
  },
  data() {
    return {
      optinGroup: [],
      isOptinOpen: false,
      optinPhone: false,
      optinEmail: false,
    }
  },
  computed: {
    ...mapGetters({
      phone: '$_checkout/phoneOptin',
      email: '$_checkout/emailOptin',
    }),
  },
  methods: {
    ...mapActions({
      change: '$_checkout/setOptinOptions',
    }),
    optInTrigger() {
      this.change({phone: this.optinPhone, email: this.optinEmail})
    },
  },
  mounted() {
    this.optinPhone = this.phone
    this.optinEmail = this.email
  },
}
</script>

<style scoped lang="sass"></style>
